var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:("MainLogo " + (_vm.className || '')),style:({ cursor: 'pointer' }),attrs:{"src":_vm.image || _vm.logo},on:{"click":function($event){return _vm.$router.push({ name: 'Start' })}}})}
var staticRenderFns = []

export { render, staticRenderFns }